import Entity from './entity'

export default class CreateQuestionnaireInput extends Entity<string>{
    // 问卷名称
    name: string;
    //问卷说明
    instructions: string;
}